import React, { FC, useCallback } from 'react';

import ActionRow from './ActionRow';
import { ActionType, RouteToAgentAction as RouteToAgentActionType } from 'src/actions/rules/actions';
import { StyledDropdown, StyledTypeDescription } from 'src/presentation/components/pages/rules/shared/StyledComponents';
import useAgents from 'src/presentation/components/pages/rules/hooks/useAgents';

type RouteToAgentActionProps = {
  action: RouteToAgentActionType;
  onDelete: Function;
  onUpdate: Function;
};

const RouteToAgentAction: FC<RouteToAgentActionProps> = ({ action, onDelete, onUpdate }) => {
  const { loadingState, values: agentOptions } = useAgents();

  const onChangeAgent = useCallback(
    agentId => {
      action.updateAgent(agentId);
      onUpdate(ActionType.RouteToAgent, action);
    },
    [action, onUpdate]
  );

  if (loadingState === 'loading') return null;
  return (
    <ActionRow type={ActionType.RouteToAgent} onDelete={onDelete}>
      <StyledTypeDescription>Assign to Agent</StyledTypeDescription>
      <StyledDropdown
        data-aid="assignAgent-selectButton"
        maxRows={5}
        onSelect={onChangeAgent}
        options={agentOptions}
        placeholder="Select agent"
        searchable
        value={action.agentId}
      />
    </ActionRow>
  );
};

export default RouteToAgentAction;
